import { useState } from "react";
import Button from "./Button";
import WishCreatePopup from "./WishCreatePopup";

export default function AddWishButton() {
  const [addOpen, setAddOpen] = useState(false);

  return (
    <>
      <Button
        className="hidden! md:block!"
        onClick={() => setAddOpen(true)}
        data-testid="add-wish"
      >
        Add a wish
      </Button>
      <WishCreatePopup isModalOpen={addOpen} close={() => setAddOpen(false)} />
    </>
  );
}
